import React, {useEffect, useMemo, useState} from 'react'
import {useFormContext} from "react-hook-form";

import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.min.css'
import '@uppy/webcam/dist/style.min.css'
import classNames from "classnames";

import Uppy from '@uppy/core'
import {DashboardModal} from '@uppy/react'
import Webcam from '@uppy/webcam'

import {useOptionValues, useFormFieldAttributes} from "../../utils"
import CustomError from './custom_error'

const ALLOWED_FILE_TYPES = ["image/gif", "image/jpeg", "image/png"]
const uppy = new Uppy()
const backendFieldName = 'tag_owner_images'

const UppyModalUploader = ({buttonLabel, formMode, field, pinturaConfig}) => {
  const {register, clearErrors, setValue} = useFormContext();
  const [open, setOpen] = useState(false)
  const [selectedFileName, setSelectedFileName] = useState()

  const uppy = useMemo(() => {
    return new Uppy({
      restrictions: {
        maxFileSize: 3000000,
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
        allowedFileTypes: ALLOWED_FILE_TYPES
      },
      onBeforeFileAdded: (file) => {
        //console.log(file)
        if (file.handledByDoka) {
          setOpen(false)
          clearErrors(backendFieldName)
          setValue(backendFieldName, {"0": file.data})
          return true;
        }

        doka.edit(file.data).then(output => { // add the Doka edit result back to Uppy
          setSelectedFileName(file?.data?.name)
          setOpen(false)
          clearErrors(backendFieldName)
          setValue(backendFieldName, {"0": output.file})
        });

        setOpen(false)
        clearErrors(backendFieldName)
        setValue(backendFieldName, {"0": file.data})
        return false;
      },
    })
    .use(Webcam, {
      countdown: false,
      mirror: false,
      showRecordingLength: false,
      preferredVideoMimeType: null,
      preferredImageMimeType: null,
      modes: ['picture'],
      videoConstraints: {
        facingMode: 'environment',
        showVideoSourceDropdown: true,
        width: { min: 720, ideal: 1280, max: 1920 },
        height: { min: 480, ideal: 800, max: 1080 },
      },
      locale: {},
    })
  }, [])

  const doka = useMemo(() => {
    console.log({pinturaConfig})
    return new Doka.create({
      utils: ['crop'], // , 'filter', 'color'
      ...pinturaConfig
    })
  }, [])

  useEffect(() => {
    uppy.on('file-removed', (file, reason) => {
      clearErrors(backendFieldName)
      setValue(backendFieldName, {})
    })
    return () => uppy.close()
  }, [])

  const handleOnButtonClick = () => {
    uppy.reset()
    setValue(backendFieldName, {})
    setOpen(true)
  }

  return <>
    <button
      type={"button"}
      className="btn btn-light btn-block"
      id="uppy-modal-btn"
      onClick={handleOnButtonClick}
    >
      {buttonLabel}
    </button>

    {selectedFileName && <small className={"uppy-file-name"}>
      {selectedFileName}
    </small>}
    <DashboardModal
      uppy={uppy}
      open={open}
      closeModalOnClickOutside
      onRequestClose={setOpen}
      hideUploadButton={true}
      plugins={['Webcam']}
    />
  </>
}

const TagOwnerImageFormField = ({field, formMode, type}) => {
  const {
    labelWidth,
    inputWidth,
    title,
    fieldValue,
  } = useFormFieldAttributes(formMode, field)
  const optionValues = useOptionValues(formMode, field)
  const { formState: { errors } } = useFormContext();
  const errorMessage = (errors[backendFieldName])

  const {register, clearErrors, setValue} = useFormContext();
  const [customFileInputLabel, setCustomFileInputLabel] = useState(title)
  const [selectedFileName, setSelectedFileName] = useState()

  const pinturaConfig = useMemo(() => {
    if (fieldValue) {
      try {
        return JSON.parse(fieldValue)
      } catch(e) {
        alert(e)
      }
    }

    return {}
  }, [fieldValue])


  let customFileInputDefaultLabel = title
  optionValues.map(row => {
    const key = row[0]
    const value = row[1]

    if (key === "custom-file-input-default-label") {
      customFileInputDefaultLabel = value
    }
  })

  useEffect(() => {
    setCustomFileInputLabel(customFileInputDefaultLabel)
  }, [])

  let inputContent = <div className="custom-file">
    <input
      type="file"
      accept={ALLOWED_FILE_TYPES.join(", ")}
      className={classNames("custom-file-input form-control-sm", {"is-invalid": errorMessage})}
      id={backendFieldName}
      name={backendFieldName}
      onChange={(e) => {
        //console.log(e.target?.files)
        if (e.target?.files && e.target.files[0].name) {
          setSelectedFileName(e.target.files[0].name)
        } else {
          setSelectedFileName("")
        }
        clearErrors(backendFieldName)
      }}
    />
    <label
      className={classNames("custom-file-label col-form-label-sm text-left", {"is-invalid": errorMessage})}
      htmlFor={backendFieldName}
    >
      {selectedFileName || customFileInputLabel}
    </label>
    <CustomError error={errorMessage}/>
  </div>

  if (type === "tag_owner_image_uppy") {
    let buttonLabel = "Click to select a file."
    if (optionValues) {
      optionValues.map(row => {
        const key = row[0]
        const value = row[1]

        if (key === "button-label") {
          buttonLabel = value
        }
      })
    }

    inputContent = <>
      <div className={classNames({"is-invalid": errorMessage})}>
        <UppyModalUploader
          buttonLabel={buttonLabel}
          formMode={formMode}
          field={field}
          pinturaConfig={pinturaConfig}
        />
      </div>
      <CustomError error={errorMessage}/>
    </>
  }

  return <div className="form-group row" id={`form-group-${field}`} key={field}>
    <label htmlFor={backendFieldName} id={field}
           className={`col-md-${labelWidth} r-label col-form-label`}>
      {title || field}
    </label>
    <div className={`col-md-${inputWidth}`}>
      {inputContent}
    </div>
  </div>
}

export default TagOwnerImageFormField
